module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "List_of_Plates"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("List of Plates")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "list-fig"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1    HM King George V. (Library of Congress)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2    Emperor Wilhelm II of Germany, on the left, and Tsar Nicholas II of Russia, 1905. (Library of Congress)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3    Emperor Franz Josef of Austria/Hungary. (Library of Congress)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4    British Prime Minister, the Rt. Hon. HH Asquith MP. (Library of Congress)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5    British Foreign Secretary, the Rt. Hon. Sir Edward Grey, MP. (Library of Congress)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6    German Chancellor, Theobald von Bethmann-Hollweg. (Library of Congress)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7    General Count Franz Conrad von Hotzendorf, Austrian Chief of Staff. (Library of Congress)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8    The Rt. Hon. Winston S Churchill, MP, British First Lord of the Admiralty. (Library of Congress)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9    The Rt. Hon. David Lloyd George, MP, Chancellor of the Exchequer. (Library of Congress)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10  Field Marshal Lord Kitchener. (Library of Congress)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11  Admiral of the Fleet, Sir John Fisher. (Library of Congress)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12  Lord Haldane, Secretary of State for War, 1905–12. (Library of Congress)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13  Sergei Sazonov, Russian Foreign Minister. (Wikimedia Commons)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14  Nikola Paši"), _c('span', {
    staticClass: "entity"
  }, [_vm._v("ć")]), _vm._v(", Prime Minister of Serbia. (Wikimedia Commons)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15  The Rt. Hon. John Redmond, MP, Irish Nationalist politician. (PD, UK, unknown)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16  The Rt. Hon. Sir Edward Carson, Irish Unionist politician. (Ulster Volunteer Association)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17  The ‘Declaration of War’ proclaimed in Richmond, North Yorkshire. (Museum of the Green Howards, Richmond, North Yorkshire)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18  Recruitment poster for the Green Howards in Scarborough. (Museum of the Green Howards, Richmond, North Yorkshire)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19  The foundering of HMS "), _c('i', [_vm._v("Aboukir")]), _vm._v(", 22 September 1914. (National Museum of the Royal Navy)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20  HMS "), _c('i', [_vm._v("Lion")]), _vm._v(", severely damaged at the Battle of Dogger Bank, 24 January 1915, approaches Rosyth. (Courtesy of Nicholas Beatty, temporarily on loan to the National Museum of the Royal Navy)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21  SMS "), _c('i', [_vm._v("Königsberg")]), _vm._v(", grounded in the Rufiji River following Royal Navy shelling. (National Museum of the Royal Navy)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22  Field Marshal Sir John French. (Spencer Jones)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23  An artist’s impression of a British rearguard in August 1914. (Spencer Jones)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24  Volunteers, Central London Recruiting Depot, Great Scotland Yard. (IWM Q 81797)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25  Recruits of the Sheffield City Battalion (12th Yorks and Lancaster Regiment) drilling at Bramall Lane, Sheffield, in September 1914. (IWM HU 37016)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26  The railway bridge at Nimy, held on 23 August 1914 by Private Sidney Frank Godley. (Matthew Richardson)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27  Private Arthur Green, Somerset Light Infantry. Badly wounded and captured at Le Cateau. (Matthew Richardson)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28  German soldiers sweep across a French cornfield in August 1914. (Matthew Richardson)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29  An aerial view of the Ypres battlefield as it appeared in 1914. (Matthew Richardson)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30  Captain Mark Haggard, 2nd Battalion Welsh Regiment, killed at the Battle of the Aisne. (Matthew Richardson)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31  The German writer, Paul Oskar Hocker, a captain in a reserve regiment. (Matthew Richardson)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#ufig_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32  Gheluvelt village in 1914. (Matthew Richardson)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33  The 2nd Battalion The Yorkshire Regiment, march through St Peter Port, Guernsey, to embark on troopships to join the 7th Division encamped near Southampton. (The Museum of the Green Howards, Richmond)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34  RQMS Tom Riordan on his wedding day, 2 November 1919. (The Museum of the Green Howards, Richmond)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35  Officers of the 2nd Battalion The Yorkshire Regiment, at a training camp on Blackdown Heath, waiting to join the British Expeditionary Force in Belgium and France. (The Museum of the Green Howards, Richmond)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36  Lieutenant F. C. Legard, (2nd Battalion The Yorkshire Regiment) with his Vickers Medium Machine-gun Section, prior to the move to Belgium in September 1914. (The Museum of the Green Howards, Richmond)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37  The Menin Cross Roads occupied by the 2nd Battalion The Yorkshire Regiment, (Green Howards) during the First Battle of Ypres, October 1914. (The Museum of the Green Howards, Richmond)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38  Captain B. H. Leatham, (2nd Yorkshires) visits his men in the trenches after the First Battle of Ypres. (The Museum of the Green Howards, Richmond)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39  Life in Ruhleben Internment Camp, near Berlin: one of the stable blocks converted to barracks. (Liddle Collection, University of Leeds)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40  Kindred companions, Box 23, Barrack X1, Ruhleben. (WE Swale, Liddle Collection, University of Leeds)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41  An artist’s impression of one of the Ruhleben stable boxes. (WE Swale, Liddle Collection, University of Leeds)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42  Ruhleben and an ice skating opportunity. (Liddle Collection, University of Leeds)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43  Prizewinners at a Ruhleben Vegetable Show. (Liddle Collection, University of Leeds)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44  Ruhleben Dramatic Society’s production of "), _c('i', [_vm._v("A School for Scandal")]), _vm._v(". (Liddle Collection, University of Leeds)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45  Steve Bloomer (left) and Fred Pentland, among the football coaches engaged by German clubs and consequently interned at Ruhleben. (Liddle Collection, University of Leeds)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46  An internee’s sketch of the riot at Douglas Camp on the Isle of Man, November 1914. (Courtesy of Manx National Heritage)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47  Frederic Dunbar-Kalkreuth, a wealthy German, interned at Douglas Camp. (Matthew Richardson)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48  Jewish internees at Douglas Camp. (Courtesy of Manx National Heritage)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49  The Hungarian, Paul Stoffa, interned at Knockaloe on the Isle of Man. (Matthew Richardson)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50  Hans Breitenstrater, a German for whom boxing was his salvation at Knockaloe Camp. (Matthew Richardson)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51  "), _c('i', [_vm._v("Maschinengewehr 08")]), _vm._v(", the German Army’s standard machine-gun. (Infantry and SASC Weapons Collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52  The Vickers machine-gun, the British Army’s standard machine-gun. (Infantry and SASC Weapons Collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53  The British SMLE (Short Magazine Lee-Enfield) No1 Mk3, the standard British rifle. (Infantry and SASC Weapons Collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54  "), _c('i', [_vm._v("Gewehr 98")]), _vm._v(" rifle, the standard German rifle. (Infantry and SASC Weapons Collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55  Lewis Gun, the British light machine-gun. (Infantry and SASC Weapons Collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56  "), _c('i', [_vm._v("MG 08/15")]), _vm._v(", the German light machine-gun. (Internet Public Domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57  Stokes Mortar, the British trench mortar. (Internet Public Domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58  "), _c('i', [_vm._v("G 98 K")]), _vm._v(", the rifle for German snipers. (Infantry and SASC Weapons Collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59  "), _c('i', [_vm._v("MP 18")]), _vm._v(", the German sub-machine-gun. (Infantry and SASC Weapons Collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#ufig_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60  WEX, a small German flamethrower. (Internet Public Domain)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61  The famous French 75 field gun, "), _c('i', [_vm._v("Canon de Mle 75, 1897")]), _vm._v(". (Courtesy of the Trustees of the Royal Armouries)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62  "), _c('i', [_vm._v("Canon de Mle 75, 1897")]), _vm._v(", showing the breech mechanism. (Courtesy of the Trustees of the Royal Armouries).")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63  The German field gun, "), _c('i', [_vm._v("77mm FK 96 n.A")]), _vm._v(". (Courtesy of the Trustees of the Royal Armouries).")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64  The British field gun, the 18-pounder Quick-Firing Gun. (Courtesy of the Trustees of the Royal Armouries).")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65  French cuirassiers, Paris, August 1914. (Wikimedia Commons)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66  Mules floundering in the mud of the Western Front. (Canada in the Great War Series)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67  German motorcycle pigeon carrier. (http://justacarguy.blogspot.com/)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68  British pilot with ‘flying fox’ mascot. (Mary Evans Picture Library)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69  Airedale messenger and first aid dogs, the latter wearing a gasmask. (‘Animals in War Dedication Project, Canada’)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70  Canadian War Memorial to Animals. (‘Animals in War Dedication Project, Canada’)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71  The Henri Farman F20, designed by a Englishman living in France. (Nick Forder)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72  Zeppelin "), _c('i', [_vm._v("L3")]), _vm._v(", the sole operational rigid airship available to the German Navy on the outbreak of war. (Nick Forder)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73  Royal Aircraft Factory BE2. The pilot sat in the rear seat and the observer in the front. (Nick Forder)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74  A Mobile Wireless Ground Station. (Nick Forder)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75  William Sefton Brancker, appointed Assistant Director of Military Aeronautics in October, 1913. (Royal Aero Club)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76  Philip Bennet Joubert de la Ferté flew one of the first two reconnaissances by the RFC. (Royal Aero Club)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#fig_77a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77  Louis Arbon Strange graduated from the Central Flying School in May 1914. He joined Number 5 Squadron and flew a Farman F20 to France on 15 August. (Royal Aero Club)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78  James Byford McCudden, VC, joined the RFC in 1913 to become an engine fitter, but became an exceptionally successful fighter pilot. (Royal Aero Club)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79  Nurse Ada Bramley. (family permission)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80  A Novitiate French nurse, "), _c('i', [_vm._v("Illustrated War News")]), _vm._v(", 1916.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81  The popular image of the nurse, "), _c('i', [_vm._v("Newnes Illustrated")]), _vm._v(", June 1915.")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82  Adolphus, the mascot of fighter pilot Maurice le Blanc Smith. (Liddle Collection, University of Leeds)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83  An annotated photograph from the album of T. L. W. Stallibrass, an Observer in Number 3 Squadron RFC. (Liddle Collection, University of Leeds)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84  A diary record of the German use of gas at the Second Battle of Ypres in April 1915. (N. C. Harbutt, Liddle Collection, University of Leeds)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85  The envelope of a letter to Conscientious Objector, Howard Marten, under Court Martial in France. (Liddle Collection, University of Leeds)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86  Royal Marine fiddles to the rescue in a desperate emergency, 18.3.15, at the Dardanelles. (B Sebastian, Liddle Collection, University of Leeds)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87  The Ives Memorial, Lawnswood Cemetery, Leeds. (Andrea Hetherington)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88  The War Memorial, Lawnswood Cemetery, Leeds. (Andrea Hetherington)")])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20#ufig_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89  One of the brass plaques adorning the War Memorial, Lawnswood Cemetery, Leeds. (Andrea Hetherington)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5a72020","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_List_of_Plates.vue
// module id = 66
// module chunks = 0